import { useEffect } from "react";
import LegalLayout, { H2, P, UL } from "@/components/site/LegalLayout";
import { AGENCY } from "@/data/content";

export default function Privacy() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <P>
        This Privacy Policy describes how Doug Jones Insurance and Financial Planning Agency ("we," "us," or "our") collects, uses,
        and protects the personal information you provide through our website at anicobr.com, by phone, or in person.
        By using our website or submitting a form, you agree to the practices described below.
      </P>

      <H2>Information We Collect</H2>
      <P>When you request a quote or contact us, we may collect:</P>
      <UL>
        <li>Contact details you provide: name, email address, and phone number.</li>
        <li>Details about your insurance needs (e.g., line of business and any message you send us).</li>
        <li>Your consent preference for receiving SMS/text messages.</li>
      </UL>

      <H2>How We Use Your Information</H2>
      <UL>
        <li>To respond to your quote request or message and provide insurance services.</li>
        <li>To contact you by phone, email, or text message (only if you opted in) about your quote, policy, or account.</li>
        <li>To comply with legal, regulatory, and insurance carrier requirements.</li>
      </UL>

      <H2>SMS / Text Messaging</H2>
      <P>
        If you opt in to text messages, we use your mobile number solely to communicate with you about your
        quote, policy, and account. Message frequency varies. Message and data rates may apply. You can opt out
        at any time by replying <strong>STOP</strong>, or reply <strong>HELP</strong> for assistance.
      </P>
      <P>
        <strong>
          No mobile information will be shared with third parties or affiliates for marketing or promotional
          purposes. All of the above categories exclude text messaging originator opt-in data and consent; this
          information will not be shared with any third parties.
        </strong>
      </P>

      <H2>How We Share Information</H2>
      <P>
        We may share the information you provide with insurance carriers and underwriters strictly to obtain quotes
        and service your policies. We do not sell your personal information. As stated above, SMS opt-in consent and
        phone numbers collected for texting are never shared with third parties for their own marketing.
      </P>

      <H2>Data Security & Retention</H2>
      <P>
        We take reasonable measures to protect your information and retain it only as long as necessary to provide
        our services and meet legal obligations.
      </P>

      <H2>Your Choices</H2>
      <UL>
        <li>Opt out of texts anytime by replying STOP.</li>
        <li>Request that we update or delete your information by contacting us.</li>
      </UL>

      <H2>Contact Us</H2>
      <P>
        Doug Jones Insurance and Financial Planning Agency · {AGENCY.address} · Phone: {AGENCY.phone} · Email: {AGENCY.email}
      </P>
    </LegalLayout>
  );
}
